import React from 'react';
import toast from 'react-hot-toast';
import { Button, Card, CardContent, Stack } from '@mui/material';
import { getRecruitmentNewsBaner, updateRecruitmentNewsBaner } from '../../../services/request';
import { useMutation, useQuery } from 'react-fetching-library';
import ImageModal from '../generics/components/ImageModal';

export const NewsBanerRecord = () => {
  const fileInputRef = React.useRef();
  const [openImage, setOpenImage] = React.useState(false);
  const [preview, setPreview] = React.useState(null);
  const { mutate } = useMutation(updateRecruitmentNewsBaner);
  const { loading, payload, error } = useQuery(getRecruitmentNewsBaner());

  const handleChangeImage = async e => {
    const image = e.target.files[0];
    if (['image/jpg', 'image/jpeg', 'image/png'].includes(image.type)) {
      const formData = new FormData();
      formData.append('photo', image);
      const { error, payload, loading } = await mutate(formData);
      if (!error && !loading) {
        const r = new FileReader();
        r.onload = e => {
          setPreview(e.target.result);
        };
        r.readAsDataURL(image);
      } else {
        toast.error('Nie udało się wczytać pliku');
      }
    } else {
      toast.error('Nieprawidłowy format pliku. Proszę wczytać plik w formacie JPG/JPEG/PNG.');
    }
  };

  React.useEffect(() => {
    if (!error && !loading) {
      setPreview(payload.recruitment_news_baner);
    }
  }, [loading]);

  return (
    <Card sx={{ height: '250px', width: '50%' }}>
      <CardContent>
        <img
          src={preview}
          style={{ objectFit: 'cover', width: '150px', height: '150px', margin: '0 auto', border: '2px solid #00AB55', borderRadius: '16px', cursor: 'zoom-in' }}
          onClick={() => setOpenImage(true)}
        >
        </img>
        <Stack style={{ marginTop: '10px' }} direction="row" justifyContent="space-between">
          <Button variant="contained" component="label">
              Zmień
            <input type="file" accept="image/*" hidden ref={fileInputRef} onChange={handleChangeImage}/>
          </Button>
        </Stack>
      </CardContent>
      <ImageModal open={openImage} handleClose={() => setOpenImage(false)} src={preview}/>
    </Card>
  );
};
